module.exports = __webpack_public_path__ + "img/2-1.cc9e1952.png";